import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Motoristas() {
  const [motoristasList, setMotoristasList] = useState([]);

  const [novoNome, setNovoNome] = useState('');
  const [novaCnh, setNovaCnh] = useState('');
  const [novoEmail, setNovoEmail] = useState('');
  const [novoSenha, setNovoSenha] = useState('');

  const [editandoId, setEditandoId] = useState(null);
  const [nomeEdit, setNomeEdit] = useState('');
  const [cnhEdit, setCnhEdit] = useState('');
  const [emailEdit, setEmailEdit] = useState('');

  useEffect(() => {
    carregarMotoristas();
  }, []);

  const carregarMotoristas = async () => {
    try {
      const response = await api.get('/motoristas');
      setMotoristasList(
        Array.isArray(response.data) ? response.data : []
      );
    } catch (err) {
      console.error(
        'Erro ao carregar motoristas:',
        err.response || err
      );
    }
  };

  const adicionarMotorista = async () => {
    if (!novoNome || !novaCnh || !novoEmail || !novoSenha) {
      alert('Preencha todos os campos de cadastro.');
      return;
    }

    const novoMot = {
      id: Date.now().toString(),
      nome: novoNome.trim(),
      cnh: novaCnh.trim(),
      email: novoEmail.toLowerCase().trim(),
      senha: novoSenha,
      telefone: '',
      status: 'Ativo'
    };

    try {
      await api.post('/motoristas', novoMot);

      await carregarMotoristas();

      setNovoNome('');
      setNovaCnh('');
      setNovoEmail('');
      setNovoSenha('');

      alert(
        'Motorista e credenciais de acesso criados com sucesso!'
      );
    } catch (err) {
      console.error(
        'Erro ao cadastrar motorista:',
        err.response || err
      );

      const detalhe =
        err.response?.data?.detail ||
        'Erro ao cadastrar motorista no servidor.';

      alert(detalhe);
    }
  };

  const excluirMotorista = async (id) => {
    if (!window.confirm('Deseja realmente excluir este motorista?')) {
      return;
    }

    try {
      await api.delete(`/motoristas/${id}`);
      await carregarMotoristas();
    } catch (err) {
      console.error(
        'Erro ao excluir motorista:',
        err.response || err
      );

      alert('Erro ao excluir motorista do servidor.');
    }
  };

  const iniciarEdicao = (m) => {
    setEditandoId(m.id);
    setNomeEdit(m.nome || '');
    setCnhEdit(m.cnh || '');
    setEmailEdit(m.email || '');
  };

  const cancelarEdicao = () => {
    setEditandoId(null);
    setNomeEdit('');
    setCnhEdit('');
    setEmailEdit('');
  };

  const salvarEdicao = async (id) => {
    if (!nomeEdit.trim() || !cnhEdit.trim() || !emailEdit.trim()) {
      alert('Preencha nome, CNH e e-mail.');
      return;
    }

    const motoristaAtual = motoristasList.find(
      (motorista) => motorista.id === id
    );

    const motAtualizado = {
      nome: nomeEdit.trim(),
      cnh: cnhEdit.trim(),
      email: emailEdit.toLowerCase().trim(),
      senha: motoristaAtual?.senha || '',
      telefone: motoristaAtual?.telefone || '',
      veiculo: motoristaAtual?.veiculo || '',
      status: motoristaAtual?.status || 'Ativo'
    };

    try {
      await api.put(`/motoristas/${id}`, motAtualizado);

      await carregarMotoristas();

      cancelarEdicao();

      alert('Motorista atualizado com sucesso!');
    } catch (err) {
      console.error(
        'Erro ao atualizar motorista:',
        err.response || err
      );

      const detalhe =
        err.response?.data?.detail ||
        'Erro ao atualizar motorista.';

      alert(detalhe);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        boxSizing: 'border-box',
        padding: '20px',
        color: '#fff'
      }}
    >
      <h2
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          margin: '0 0 24px 0'
        }}
      >
        Controle de Motoristas & Credenciais
      </h2>

      <div
        style={{
          backgroundColor: '#141414',
          border: '1px solid #2a2a2a',
          padding: '24px',
          borderRadius: '8px',
          marginBottom: '24px'
        }}
      >
        <h3
          style={{
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '16px'
          }}
        >
          Cadastrar Novo Motorista e Acesso
        </h3>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '12px'
          }}
        >
          <input
            placeholder="Nome Completo"
            value={novoNome}
            onChange={(e) => setNovoNome(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="CNH"
            value={novaCnh}
            onChange={(e) => setNovaCnh(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="E-mail de Login"
            type="email"
            value={novoEmail}
            onChange={(e) => setNovoEmail(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Senha de Acesso"
            type="password"
            value={novoSenha}
            onChange={(e) => setNovoSenha(e.target.value)}
            style={inputStyle}
          />

          <button
            type="button"
            onClick={adicionarMotorista}
            style={btnAdicionar}
          >
            Adicionar
          </button>
        </div>
      </div>

      <div
        style={{
          backgroundColor: '#141414',
          border: '1px solid #2a2a2a',
          borderRadius: '8px',
          overflowX: 'auto'
        }}
      >
        <table
          style={{
            width: '100%',
            minWidth: '760px',
            borderCollapse: 'collapse',
            textAlign: 'left',
            fontSize: '14px'
          }}
        >
          <thead>
            <tr
              style={{
                borderBottom: '1px solid #2a2a2a',
                color: '#a0a0a0',
                backgroundColor: '#1a1a1a'
              }}
            >
              <th style={thStyle}>Nome</th>
              <th style={thStyle}>CNH</th>
              <th style={thStyle}>E-mail de Acesso</th>
              <th style={thStyle}>Status</th>
              <th style={{ ...thStyle, textAlign: 'right' }}>
                Ações
              </th>
            </tr>
          </thead>

          <tbody>
            {motoristasList.length === 0 ? (
              <tr>
                <td
                  colSpan="5"
                  style={{
                    textAlign: 'center',
                    padding: '30px',
                    color: '#777'
                  }}
                >
                  Nenhum motorista cadastrado.
                </td>
              </tr>
            ) : (
              motoristasList.map((m) => (
                <tr
                  key={m.id}
                  style={{
                    borderBottom: '1px solid #222'
                  }}
                >
                  <td style={tdStyle}>
                    {editandoId === m.id ? (
                      <input
                        value={nomeEdit}
                        onChange={(e) =>
                          setNomeEdit(e.target.value)
                        }
                        style={inputStyleEdit}
                      />
                    ) : (
                      <b>{m.nome}</b>
                    )}
                  </td>

                  <td style={tdStyle}>
                    {editandoId === m.id ? (
                      <input
                        value={cnhEdit}
                        onChange={(e) =>
                          setCnhEdit(e.target.value)
                        }
                        style={inputStyleEdit}
                      />
                    ) : (
                      m.cnh
                    )}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      color: '#007AFF',
                      fontFamily: 'monospace'
                    }}
                  >
                    {editandoId === m.id ? (
                      <input
                        value={emailEdit}
                        onChange={(e) =>
                          setEmailEdit(e.target.value)
                        }
                        style={inputStyleEdit}
                      />
                    ) : (
                      m.email
                    )}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      color:
                        m.status === 'Inativo'
                          ? '#FF453A'
                          : '#32D74B',
                      fontWeight: 'bold'
                    }}
                  >
                    {m.status || 'Ativo'}
                  </td>

                  <td
                    style={{
                      ...tdStyle,
                      textAlign: 'right',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {editandoId === m.id ? (
                      <>
                        <button
                          type="button"
                          onClick={() => salvarEdicao(m.id)}
                          style={btnSalvar}
                        >
                          Salvar
                        </button>

                        <button
                          type="button"
                          onClick={cancelarEdicao}
                          style={btnCancelar}
                        >
                          Cancelar
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        onClick={() => iniciarEdicao(m)}
                        style={btnEditar}
                      >
                        Editar
                      </button>
                    )}

                    <button
                      type="button"
                      onClick={() => excluirMotorista(m.id)}
                      style={btnExcluir}
                    >
                      Excluir
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const inputStyle = {
  padding: '11px',
  backgroundColor: '#1a1a1a',
  border: '1px solid #333',
  borderRadius: '6px',
  color: '#fff',
  boxSizing: 'border-box',
  width: '100%'
};

const inputStyleEdit = {
  padding: '7px',
  background: '#222',
  border: '1px solid #444',
  color: '#fff',
  borderRadius: '4px',
  width: '100%',
  boxSizing: 'border-box'
};

const thStyle = {
  padding: '16px'
};

const tdStyle = {
  padding: '16px'
};

const btnAdicionar = {
  padding: '11px 20px',
  backgroundColor: '#007AFF',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const btnSalvar = {
  padding: '6px 12px',
  backgroundColor: '#32D74B',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  marginRight: '8px',
  cursor: 'pointer',
  fontWeight: 'bold'
};

const btnCancelar = {
  padding: '6px 12px',
  backgroundColor: '#555',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  marginRight: '8px',
  cursor: 'pointer'
};

const btnEditar = {
  padding: '6px 12px',
  backgroundColor: '#333',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  marginRight: '8px',
  cursor: 'pointer'
};

const btnExcluir = {
  padding: '6px 12px',
  backgroundColor: '#FF3B30',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};